import { render, staticRenderFns } from "./mobile-nav-primary.vue?vue&type=template&id=61fb28f3&scoped=true&"
import script from "./mobile-nav-primary.vue?vue&type=script&lang=js&"
export * from "./mobile-nav-primary.vue?vue&type=script&lang=js&"
import style0 from "./mobile-nav-primary.vue?vue&type=style&index=0&id=61fb28f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb28f3",
  null
  
)

export default component.exports